<template>
  <roe-error-message :field="design.age_requirement_months">
    <input
      type="number"
      v-model.number="design.$model.age_requirement_months"
      required
      min="0"
      @change="updateRequirementConnectedModels()"
    />
    <label class="input-label-inside">months</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeAgeRequirementMonthsInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  methods: {
    updateRequirementConnectedModels() {
      if (
        (+this.design.$model.age_requirement_employer_match === 1 &&
          +this.design.$model.age_requirement_employee_deferrals !== 0) ||
        +this.design.$model.age_requirement_sync === 1
      ) {
        this.design.$model.age_requirement_match_months = this.design.$model.age_requirement_months;
      }

      if (
        +this.design.$model.age_requirement_profit_sharing === 1 &&
        +this.design.$model.age_requirement_employee_deferrals !== 0
      ) {
        this.design.$model.age_requirement_profit_sharing_months = this.design.$model.age_requirement_months;
      }
    }
  }
};
</script>
